interface LongArrowDownProps {
  color: string;
}

const LongArrowDown = ({ color }: LongArrowDownProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: 'rotate(180deg)' }}
  >
    <path d="M12.6364 2.3636C12.2849 2.01213 11.7151 2.01213 11.3636 2.3636L5.63604 8.09117C5.28457 8.44264 5.28457 9.01249 5.63604 9.36396C5.98751 9.71543 6.55736 9.71543 6.90883 9.36396L12 4.27279L17.0912 9.36396C17.4426 9.71543 18.0125 9.71543 18.364 9.36396C18.7154 9.01249 18.7154 8.44264 18.364 8.09117L12.6364 2.3636ZM12 21L12.9 21L12.9 3L12 3L11.1 3L11.1 21L12 21Z" fill={color} />
  </svg>
);

export default LongArrowDown;
